export default "__VITE_ASSET__lJj7kYkV__"